import type { StripeSetupFailure } from 'src/app/shared/api/payments';

export function hasGatewayErrorData(error: unknown): error is StripeSetupFailure {
	return typeof error === 'object' && error !== null && 'gatewayErrorData' in error;
}
